export default "__VITE_ASSET__DpdT5$GO__"